import { Section } from 'Container';
import styled from 'styled-components';
import { breakpoints, colors } from 'components/Theme';
import { asRem } from 'utils';

export const HealthInsuranceSliderSectionStyle = styled(Section)`
  padding-top: 0;
  align-items: center;
  height: ${asRem(480)};

  @media (min-width: ${breakpoints.md}) {
    height: ${asRem(380)};
  }

  .white-hr {
    border: none;
    border-top: 2px solid white;
    margin-bottom: ${asRem(50)};
    width: 90%;
    margin-left: auto;
    margin-right: auto;

    @media (min-width: ${breakpoints.lg}) {
      width: 100%;
    }
  }

  .slider-wrapper {
    text-align: center;
  }

  .dark-pink-dots {
    margin-top: ${asRem(30)};

    .mime-elements-arrow svg path {
      stroke: white;
      fill: white;

      &:hover {
        stroke: ${colors.pink.c800};
        fill: ${colors.pink.c800};
      }
    }
    .mime-elements-arrow:hover svg path {
      stroke: ${colors.pink.c800};
      fill: ${colors.pink.c800};
    }
  }

  .health-cooperation-slider {
    height: ${asRem(230)};

    @media (min-width: ${breakpoints.md}) {
      height: ${asRem(240)};
    }
  }

  .slider-body {
    margin-top: ${asRem(50)};
    padding-left: ${asRem(40)};
    padding-right: ${asRem(40)};
    padding-bottom: ${asRem(20)};
    margin-left: auto;
    margin-right: auto;

    @media (min-width: ${breakpoints.md}) {
      padding-horizontal: ${asRem(100)};
      margin-top: ${asRem(35)};
    }

    @media (min-width: ${breakpoints.lg}) {
      width: 100%;
    }

    @media (min-width: ${breakpoints.xl}) {
      width: 70%;
    }
  }

  .logo {
    aspect-ratio: 100 / 50;
    width: ${asRem(100)};
    height: ${asRem(50)};
    margin: 0 ${asRem(4)};
    background-color: ${colors.white.c500};
    border-radius: ${asRem(8)};

    @media (min-width: ${breakpoints.md}) {
      width: ${asRem(140)};
      height: ${asRem(70)};
      margin: 0 ${asRem(10)};
    }
  }
`;
